import classNames from 'classnames'
import _ from 'lodash'
import { Detail, BodyLong } from '@navikt/ds-react'
import PT from 'prop-types'
import React, { useState } from 'react'
import styled from 'styled-components'
import { LayoutTemplates, WidgetAddProps, WidgetContainerProps, WidgetFC, WidgetPlaceholder } from 'index.d'
import { WidgetTemplatePropType } from 'index.pt'

export const ContentDiv = styled.div`
  padding: 0.5rem;
`
export const WidgetAddDiv = styled.div`
  width: 7rem;
  height: 6rem;
  color: var(--navds-color-text-primary); 
  background-color: var(--navds-semantic-color-canvas-background); 
  box-shadow: 2px 2px 2px var(--navds-semantic-color-border);
  margin-right: 1rem;
  cursor: move;
  transition: all 0.2s ease-out;
  overflow: hidden;
  &.selected {
    width: 0px;
    margin-right: 0px;
  }
  &.hover {
    background-color: var(--navds-semantic-color-interaction-primary-hover);
    color: var(--navds-semantic-color-canvas-background);
  }
  .content {
    line-height: 1;
  }
`

export const WidgetAdd: React.FC<WidgetAddProps> = ({
  myWidgets, onPlaceholderWidgetAdd, widgetTemplate
}: WidgetAddProps): JSX.Element => {
  const [mouseOver, setMouseOver] = useState<boolean>(false)

  const FoundWidget: WidgetFC<WidgetContainerProps> = _.find(_.values(myWidgets), (it) => {
    return it.properties ? it.properties.type === widgetTemplate.type : false
  })
  if (!FoundWidget) {
    return <div />
  }

  return (

    <WidgetAddDiv
      className={classNames('droppable-element', {
        hover: mouseOver
      })}
      key={widgetTemplate.description}
      draggable
      unselectable='on'
      onDragStart={(e: React.DragEvent) => {
        const placeholderWidget: WidgetPlaceholder = {
          i: '',
          visible: true,
          title: widgetTemplate.title,
          type: widgetTemplate.type,
          options: widgetTemplate.options,
          defaultLayout: FoundWidget.properties.layout as LayoutTemplates
        }
        onPlaceholderWidgetAdd(placeholderWidget)
        e.dataTransfer.setData('text/plain', '')
      }}
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
      title={widgetTemplate.description}
    >
      <ContentDiv>
        <Detail>
          {widgetTemplate.title}
        </Detail>
        <BodyLong>
          <small>{widgetTemplate.description}</small>
        </BodyLong>
      </ContentDiv>
    </WidgetAddDiv>
  )
}

WidgetAdd.propTypes = {
  myWidgets: PT.object.isRequired,
  onPlaceholderWidgetAdd: PT.func.isRequired,
  widgetTemplate: WidgetTemplatePropType.isRequired
}

export default WidgetAdd
